import { createFormHookContexts } from '@tanstack/react-form';

/**
 * Shared TanStack Form contexts.
 *
 * Import `fieldContext`, `formContext`, and `useFieldContext` from here
 * when creating a new feature form hook with `createFormHook(...)`.
 * This ensures reusable field components (e.g. Select with useTanstackForm) work
 * across all feature hooks without duplicate context trees.
 *
 * Usage in a feature hook:
 *   import { fieldContext, formContext } from '~/common/form/formContexts';
 *   export const { useAppForm, withForm } = createFormHook({ fieldContext, formContext, ... });
 *
 * @see tanstack-form.md
 */
export const { fieldContext, useFieldContext, formContext } =
  createFormHookContexts();
